module.exports = __webpack_public_path__ + "img/business_5.a068350e.jpg";